import { apiFetch } from "../lib/api";

export interface TokenResponse {
  access_token: string;
  token_type: string;
  expires_in: number;
}

export async function login(email: string, password: string): Promise<TokenResponse> {
  return apiFetch<TokenResponse>("/auth/login", {
    method: "POST",
    body: { email, password },
  });
}

export interface MeResponse {
  id: string;
  email: string;
  display_name: string | null;
  is_admin: boolean;
  is_active: boolean;
  last_login_at: string | null;
}

export async function getMe(): Promise<MeResponse> {
  return apiFetch<MeResponse>("/users/me");
}
